import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {ClearingHouse} from "../../model/exchange/clearing-house";
import {CrystalclearExchangeBackUrl} from "../config/crystalclear-exchange-back-url";
import {ExchangeDetail} from "../../model/exchange/exchange-detail";
import {AccountType} from "../../model/exchange/account-type";
import {TradingEnvironment} from "../../model/exchange/trading-environment";

@Injectable({
  providedIn: 'root'
})
export class ExchangeTradingEnvironmentService extends CommonCrudService<TradingEnvironment> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearExchangeBackUrl.GET_EXCHANGE_TRADING_ENVIRONMENT_LIST,
      CrystalclearExchangeBackUrl.SAVE_EXCHANGE_TRADING_ENVIRONMENT,
      CrystalclearExchangeBackUrl.DELETE_EXCHANGE_TRADING_ENVIRONMENT);
  }

}
